import { createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/app/ui/assets/svg/logo-genesis-with-text.svg'
import _imports_1 from '@/app/ui/assets/svg/login-approval/login-rejected.png'


const _hoisted_1 = {
  key: 0,
  class: "bg-gray-lp-100 w-screen h-screen flex items-center justify-center py-20"
}
const _hoisted_2 = { class: "flex flex-col items-center justify-center gap-6 mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  style: {"width":"184.5px"},
  alt: "logo genesis"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  style: {"width":"124px"},
  alt: "illustration login rejected"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "flex flex-col justify-center items-center text-center gap-8" }, [
  /*#__PURE__*/_createVNode("p", { class: "font-semibold text-2xl text-black-lp-100" }, "Login ditolak"),
  /*#__PURE__*/_createVNode("p", { class: "text-xl text-black-lp-300" }, [
    /*#__PURE__*/_createTextVNode(" Akun Anda terhubung ke beberapa perangkat. "),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createTextVNode(" Silakan hubungi Helpdesk untuk bantuan. ")
  ])
], -1)
const _hoisted_6 = { class: "flex flex-col items-center text-black-lp-100" }
const _hoisted_7 = /*#__PURE__*/_createVNode("p", null, "Butuh bantuan? Hubungi via:", -1)
const _hoisted_8 = { class: "space-x-1" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, "WhatsApp", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "space-x-1" }, [
  /*#__PURE__*/_createVNode("span", null, "Email"),
  /*#__PURE__*/_createVNode("a", {
    href: "mailto:system@thelionparcel.com",
    class: "text-red-lp-100 hover:underline"
  }, "system@thelionparcel.com")
], -1)
const _hoisted_11 = { class: "mt-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Footer = _resolveComponent("Footer")!

  return (_ctx.hasEmail)
    ? (_openBlock(), _createBlock("section", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode("div", _hoisted_8, [
              _hoisted_9,
              _createVNode("a", {
                href: `https://wa.me/${_ctx.whatsappNumberRedirect}`,
                class: "text-red-lp-100 hover:underline",
                target: "_blank",
                rel: "noopener noreferrer"
              }, _toDisplayString(_ctx.whatsappNumber), 9, ["href"])
            ]),
            _hoisted_10
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode(_component_Footer)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}